/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * Values: ACTIVE,PAUSED,CANCEL_ONLY,POST_ONLY,INITIALIZING,FINAL_SETTLEMENT
 */
@JsExport
@Serializable
enum class IndexerPerpetualMarketStatus(val value: kotlin.String) {
    ACTIVE("ACTIVE"), // :/
    PAUSED("PAUSED"), // :/
    CANCEL_ONLY("CANCEL_ONLY"), // :/
    POST_ONLY("POST_ONLY"), // :/
    INITIALIZING("INITIALIZING"), // :/
    FINAL_SETTLEMENT("FINAL_SETTLEMENT"); // :/
}
